import { Component, OnInit } from '@angular/core';
import { CertificatesService } from 'src/app/services/certificates.service';
import { CertificateData } from 'src/app/models/Doctor';
import { PromiseResult, ServerError } from 'src/app/models/PromiseResult';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-doctor-certificates',
  templateUrl: './doctor-certificates.component.html',
  styleUrls: ['./doctor-certificates.component.css']
})
export class DoctorCertificatesComponent implements OnInit {

  certificate_data: CertificateData[] = [];
  posting: boolean;
  response: PromiseResult;
  serverError: ServerError;
  constructor(private readonly certificateService: CertificatesService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.getOwnedCertificates();
  }


  getOwnedCertificates() {
    this.certificateService.GetOwnedCertificates().toPromise()
      .then(result => {
        if (result.success) {
          this.certificate_data = [];
          let ans: CertificateData[] = [];
          let data = result.data.rows;
          console.log("Certificates:", result.data.rows);
          for (let i = 0; i < data.length; i++) {
            ans.push({
              document_name: result.data.rows[i].document_name,
              document_url: result.data.rows[i].document_url,
              expires_on: result.data.rows[i].expires_on
            });
          }
          this.certificate_data = ans;
          ans = [];
        } else {
          this.response = result;
        }

        this.posting = false;
      }).catch((error) => {
        console.log(error);
      });
  }


  openDocument(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }

  downloadBase64PDF(apiUrl: string): void {
    this.http.get(apiUrl).subscribe((res: any) => {
      if (res?.data?.base64 && res?.data?.filename) {
        const base64 = res.data.base64;
        const filename = res.data.filename;
        const mimeType = res.data.mime_type || 'application/pdf';

        // Remove the "data:<type>;base64," prefix if present
        const base64Data = base64.includes(',') ? base64.split(',')[1] : base64;

        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error('Invalid base64 response');
      }
    });
  }


}
